import { format, utcToZonedTime } from "date-fns-tz";
import { DEFAULT_DATE_TIME_FORMAT } from "../components/Defaults";

export const formatLocalDate = (date) => {
  let timeZone = "Asia/Kolkata";
  let dateLocal = utcToZonedTime(date, timeZone);
  return format(dateLocal, DEFAULT_DATE_TIME_FORMAT);
};
